import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectSource } from 'shared/selectors';
import { getJsonQuery } from 'shared/selectors/getJsonQuery';
import { selectIsMixedListing, selectIsNewbuildingListing } from 'shared/selectors/listingType';

import { trackBannerClick, trackBannerShow } from './tracking';
import { NewbuildingPrizeBanner } from '../../components/NewbuildingPrizeBanner';

const NEWBUILDING_PRIZE_URL = 'https://promo.cian.site/novostroyki-priz?cian_source=kvartiri_listing';
const MIXED_PRIZE_URL = 'https://promo.cian.site/novostroyki-priz?cian_source=smeshanniy_listing';

export const NewbuildingPrizeBannerContainer: React.FC = () => {
  const jsonQuery = useSelector(getJsonQuery);
  const source = useSelector(selectSource);
  const isMixedListing = useSelector(selectIsMixedListing);
  const isNewbuildingListing = useSelector(selectIsNewbuildingListing);

  const resolvedSource = React.useMemo(() => {
    if (source) {
      return source;
    }

    if (isMixedListing) {
      return 'MixedListing';
    }

    if (isNewbuildingListing) {
      return 'NewBuildingListing';
    }

    return undefined;
  }, [isMixedListing, isNewbuildingListing, source]);

  const url = React.useMemo(() => {
    if (isMixedListing) {
      return MIXED_PRIZE_URL;
    }

    return NEWBUILDING_PRIZE_URL;
  }, [isMixedListing]);

  const handleClick = React.useCallback(() => {
    trackBannerClick(jsonQuery, resolvedSource);
  }, [jsonQuery, resolvedSource]);

  const handleShow = React.useCallback(() => {
    trackBannerShow(jsonQuery, resolvedSource);
  }, [jsonQuery, resolvedSource]);

  return (
    <ActionAfterViewObserver callback={handleShow} triggerOnce>
      <NewbuildingPrizeBanner url={url} onClick={handleClick} />
    </ActionAfterViewObserver>
  );
};
